import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

function Root() {
  // useEffect(() => {
  //   window.history.replaceState(null, "", "http://localhost:3000/api/tournament/tennisaustralia2019");
  // }, []);

  return (

    <React.StrictMode>
      <BrowserRouter >
      <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));